export const $api_Comment_AddComment = (opt: myFetchOptions) => {
    return $useHttpFetch('/api/Comment/AddComment', opt)
}
export const $api_Comment_GetCommentsBySourceIdPage = (opt: myFetchOptions) => {
    return $useHttpFetch('/api/Comment/GetCommentsBySourceIdPage', opt)
}
export const $api_Comment_DeleteComment = (opt: myFetchOptions) => {
    return $useHttpFetch('/api/Comment/DeleteComment', opt)
}
